module.exports = __webpack_public_path__ + "static/media/MY_PROJECTS_SELECTED.f94d3aed.svg";